import {
  ValidatedInput,
  ValidationMessage,
  Sidebar
} from "@/app/shared/components";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    Sidebar
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 1) {
        this.$emit("onNewData");
      } 
      else {
        this.$emit("onEditData");
      }
    }
  },
  data() {
    return {
      model: {
        id: 0,
        nameEn: "",
        nameFr: ""
      }
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    },
    tasks() {
      return this.$store.state.drilling.tasks;
    }
  },
  methods: {
    newData() {
      this.initValues();
      this.$refs.observer.reset();
    },
    editData() {
      this.model = this.data;
      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.id) return;
      this.model = {
        id: 0,
        nameEn: "",
        nameFr: ""
      }
    },
    submitData() {
      const _this = this;
      return this.$refs.observer.validate().then((result) => {
        if (result) {
          delete _this.model.tasks;
          if (_this.model.id !== null && _this.model.id > 0) {
            return this.$store.dispatch("drilling/updateCategory", _this.model)
              .then((response) => {
                _this.$emit("onUpdated", response.data.model);
                return response.data.model;
              })
              .finally(() => {
                _this.$vs.loading.close();
              });
          } else {
            return this.$store.dispatch("drilling/addCategory", _this.model)
              .then((response) => {
                _this.$emit("onInserted", response.data.model);
                _this.model.id = response.data.id;
                return response.data.model;
              })
              .finally(() => {
                _this.$vs.loading.close();
              });
          }
        }
      });
    }
  }
};
